<template class="m-0">
  <b-table :items="verInscriptosList" :fields="inscriptosFields">
    <template #cell(x_sale_order_id)="data">
      {{ data.item.x_sale_order_id[1] }}
    </template>
    <template #cell(x_student_id)="data">
      {{ data.item.x_student_id[1] }}
    </template>
    <template #cell(actions)="data">
      <b-dropdown right text="">
        <b-dropdown-item @click="verFamilia(data.item)"
          >Ver Familia</b-dropdown-item
        >
      </b-dropdown>
    </template>
    <template #row-details="data">
      <b-card>
        <b-row class="mb-2">
          <b-col sm="3" class="text-sm-right"><b>Data:</b></b-col>
          <b-col>{{ data }}</b-col>
        </b-row>

        <b-button size="sm" @click="data.toggleDetails">Hide Details</b-button>
      </b-card>
    </template>
    <template #modal-footer="{ cancel }">
      <b-button @click="cancel()"> Cerrar </b-button>
    </template>
  </b-table>
</template>

<script>
import { SaleOrdersService } from '@/services/sale.orders.service'
import { FamiliesService } from '@/services/families.service'
// import { EnrollmentsService } from '@/services/enrollments.service'

export default {
  name: 'view-class-enrollments',
  props: ['verInscriptosList'],
  data () {
    return {
      inscriptosFields: [
        { key: 'create_date', label: 'Creacion', sortable: true, sortDirection: 'desc' },
        { key: 'x_sale_order_id', label: 'Venta', sortable: true, sortDirection: 'desc' },
        { key: 'x_student_id', label: 'Alumno' },
        { key: 'x_status', label: 'Estado' },
        { key: 'actions', label: 'Acciones' }
      ]
    }
  },
  async created () {
    // this.verInscriptosList = await EnrollmentsService.read(this.enrollments_ids, [])
  },
  methods: {
    async verVenta (item) {
      const so = await SaleOrdersService.list({ name: item })
      
      this.modalSaleOrderId = so[0].id
      this.modalSaleOrderTitle = so[0].display_name + ' - ' + so[0].create_date
      this.$bvModal.show('modal-ver-venta')
    },
    async verFamilia (item) {
      console.log(item)
      const student = await FamiliesService.read([item.x_student_id[0]], [])
      console.log(student)
      this.$router.push({ path: '/families/' + student[0].parent_id[0] })
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
